import React, { useState, ChangeEvent, useEffect } from 'react'
import AsyncSelect from '../../../components/asyncSelect/AsyncSelect'
import Ingredients from '../../../components/ingredients/Ingredients'
import ModalComponent from '../../../components/modal/ModalComponent'
import ConfirmModal from '../../../components/modal/modalVariants/ConfirmModal'
import LiquidateCreateResponseOK from '../../../components/modal/modalVariants/LiquidateCreateResponseOK'
import LiquidateError from '../../../components/modal/modalVariants/LiquidateError'
import OutlinedInput from '../../../components/outlinedInput/OutlinedInput'
import OutlinedSelect from '../../../components/outlinedSelect/OutlinedSelect'
import ProductType from '../../../components/productType/ProductType'
import SvgIcon from '../../../components/svgIcon/SvgIcon'
import publishProductOk from '../../../assets/icons/inventory-publish-product-ok.png'
import greenOk from '../../../assets/icons/inventory-ok.png'
import errorRed from '../../../assets/icons/inventory-error.png'

import Text from '../../../components/text/Text'
import WarningUI from '../../../components/warning/WarningUI'
import { MEASURES } from '../../../constants'
import {
    brandsToOption,
    categoriesToOption,
    createProductFormIds,
    eansToOption,
} from '../../../formatters'
import useDisclosure from '../../../hooks/useDisclosure'
import { labels, clevertapEvents } from '../../../labels'
import {
    deleteProduct,
    getEAN,
    localBrands,
    localCategories,
} from '../../../services/products'
import styles from './individualUpload.module.css'
import useIndividualUpload from './useIndividualUpload'
import { track } from '../../../ClevertapWrapper'
import { format } from 'date-fns'
import routes from '../../../router/routes'
import { getLocal } from '../../../Utils/Profile'
import CheckBox from '../../../components/checkBox/CheckBox'
import AsyncSelectFromApi from '../../../components/asyncSelectFromApi/AsyncSelectFromApi'
import { useLocation, useNavigate } from 'react-router-dom'
import DeleteProductModal from '../../../components/modal/modalVariants/DeleteProductModal'
import { useLoadingContext } from '../../../context/spinnerContext'
import { DeleteProduct } from '../deleteProduct/DeleteProduct'

export default function IndividualUpload() {
    const navigate = useNavigate()

    const [initIngredients, setInitIngredients] = useState<any>()

    const location = useLocation()

    const loadingContext = useLoadingContext()

    const [selectedDeleteProduct, setSelectedDeleteProduct] =
        useState<IProductObject>()

    const data = location.state as IProductObject
    const isEdit = !!data

    const onDeleteProduct = async () => {
        setSelectedDeleteProduct(data)
    }

    const onDeleteCancelProduct = async () => {
        setSelectedDeleteProduct(undefined)
    }

    const onDeleteSuccessProduct = async () => {
        setSelectedDeleteProduct(undefined)
        navigate(-1)
    }

    const {
        isPublic,
        brandID,
        categoryID,
        formRef,
        errors,
        isValidForm,
        openRespnseOK,
        openResponseError,
        showError,
        form,
        setIsPublic,
        handleSelectBrand,
        handleSelectEAN,
        handleSelectCategory,
        handleChange,
        handleChangeString,
        handleChangeBoolean,
        handleSubmit,
        handleSubmitEdit,
        handleFile,
        validate,
        handleCloseResponseOk,
        handleCloseResponseError,
        handleFood,
        handleIngredients,
        handleUnit,
        handleInitForm,
    } = useIndividualUpload()
    console.log('isValidForm?????????????', isValidForm)
    useEffect(() => {
        if (data?.product) {
            console.log('FOORM', data)

            validate()

            const produ: any = {
                id: data.product.id,
                productName: data.product.productName,
                fullDescription: data.product.fullDescription,
                shortDescription: data.product.shortDescription,
                productMeasureUnit: data.product.productMeasureUnit,
                weight: data.product.weight
                    ? data.product.weight.toString()
                    : '0',
                isFood: data.product.food,
                ean: data.product.ean,
                sku: data.product.sku,
            }
            handleInitForm({
                ...produ,
                productImage: data.product.photoURL,
                costPrice: data.product.costPrice || '',
                stock: data.commerceStock.stock,
                ean: data.product.ean,
            } as unknown as ICreateProductForm)

            if (data?.ingredientTypes && data?.ingredientTypes.length > 0) {
                const ingredientsMapped = data?.ingredientTypes.map((i) => ({
                    ...i,
                    name: i.name,
                    required: i.mandatory,
                    id: i.id ? i.id : undefined,
                    maximumQuantity: String(i.maxAmount),
                    options: i.ingredients.map((j) => ({
                        ...j,
                        id:
                            j.id !== undefined && j.id !== null
                                ? String(j.id)
                                : '',
                        price: String(j.price),
                        name: j.name,
                    })),
                }))
                setInitIngredients(ingredientsMapped)
            }

            handleChangeBoolean('inStoreSales', data.commerceStock.f2f)
            handleChangeBoolean('salesInApp', data.commerceStock.online)

            setInStoreSales(data.commerceStock.f2f)
            setSalesInApp(data.commerceStock.online)

            handleSelectBrand(data.productBrand.name)
            handleSelectCategory(data.productCategories.name)
            handleChangeString(
                'stock',
                data.commerceStock.stock
                    ? data.commerceStock.stock.toString()
                    : ''
            )
            handleChangeString(
                'costPrice',
                data.productPrices[0]
                    ? data.productPrices[0].cost.toString()
                    : ''
            )
            if (data?.product?.ean) {
                setIsPublic(true)
            }
            handleChangeString(
                'price',
                data.productPrices[0]
                    ? data.productPrices[0].saleAmount.toString()
                    : ''
            )
        }
    }, [data])
    const {
        open: openConfirmDelete,
        handleClose: onCloseConfirmDelete,
        handleOpen: handleOpenConfirmDelete,
    } = useDisclosure()
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const [unit, setUnit] = useState<string>('')
    const [lat, setLat] = useState<number>(0)
    const [lng, setLng] = useState<number>(0)

    const [inStoreSales, setInStoreSales] = useState(false)
    const [salesInApp, setSalesInApp] = useState(false)
    const [showProductPolicyWarningModal, setShowProductPolicyWarningModal] =
        useState<boolean>(false)
    const [showProductPublishOkModal, setShowProductPublishOkModal] =
        useState<boolean>(false)

    const [showProductPublishErrorModal, setShowProductPublishErrorModal] =
        useState<boolean>(false)

    const clevertapData = {
        geoLocationLat: lat,
        geoLocationLong: lng,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        // ID: commerceId
    }
    const pageLoadData = {
        pageName: 'Carga de producto individual',
        pageURL: routes.individualUpload,
        geoLocationLat: lat,
        geoLocationLong: lng,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        codComercio: user?.sEstablecimiento,
        codLocal: getLocal(),
    }
    const getLocation = () => {
        navigator.geolocation.getCurrentPosition((position) => {
            setLat(position.coords.latitude)
            setLng(position.coords.longitude)
        })
    }
    const {
        open: openConfirm,
        handleClose: handleCloseConfirm,
        handleOpen: handleOpenConfirm,
    } = useDisclosure()
    const brands = brandsToOption(localBrands())

    const categories = categoriesToOption(localCategories())
    const handleUnitChange = (element: ChangeEvent<HTMLSelectElement>) => {
        handleUnit(element)
    }
    const handleClick = () => {
        track(clevertapEvents.individualCreateProduct, clevertapData)
        const isValid = validate()
        if (isValid) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            })

            handleOpenConfirm()
        }
    }

    const onSubmit = () => {
        handleCloseConfirm()
        handleSubmit()
    }

    const onCloseConfirm = () => {
        handleCloseConfirm()
    }

    const closeConfirm = openConfirm && onCloseConfirm
    const closeResponseOk = openRespnseOK && handleCloseResponseOk
    const closeResponseError = openResponseError && handleCloseResponseError
    const closeFunction = closeConfirm || closeResponseOk || closeResponseError

    useEffect(() => {
        getLocation()
    }, [lat, lng])
    useEffect(() => {
        track(clevertapEvents.pageLoacpi, pageLoadData)
    }, [])

    const onToogleInStoreSales = () => {
        handleChangeBoolean('inStoreSales', !inStoreSales)
        setInStoreSales((prevState) => !prevState)
    }

    const onToogleSalesInApp = () => {
        handleChangeBoolean('salesInApp', !salesInApp)
        setSalesInApp((prevState) => !prevState)
    }

    const productPolicyWarningModal = () => {
        return (
            <ModalComponent
                show={showProductPolicyWarningModal}
                handleClose={() => setShowProductPolicyWarningModal(false)}
                modalStyle={styles.inventoryModalStyle}
            >
                <div className={styles.inventoryModalContainer}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: 30,
                        }}
                    >
                        <img src={publishProductOk} width={138} height={115} />
                    </div>

                    <Text
                        label={`Asegúrate de que la información de tu\nproducto a publicar cumpla con las`}
                        fontSize={16}
                        fontWeight={500}
                        fontFamily={'Montserrat'}
                        textAlign={'center'}
                    />
                    <Text
                        label={`políticas de uso de`}
                        fontSize={16}
                        fontWeight={500}
                        fontFamily={'Montserrat'}
                        variant={'underline-italic'}
                        textAlign={'center'}
                    />
                    <Text
                        label={`amiPASS.`}
                        fontSize={16}
                        fontWeight={700}
                        fontFamily={'Montserrat'}
                        variant={'underline-italic'}
                        textAlign={'center'}
                    />

                    <Text
                        label="¿Desea publicar su producto?"
                        fontWeight={700}
                        fontSize={16}
                        textAlign={'center'}
                        marginTop={10}
                        marginBottom={30}
                    />
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            marginLeft: 10,
                            marginRight: 10,
                        }}
                    >
                        <div
                            style={{
                                height: 36,
                                width: 141,
                                backgroundColor: '#565656',
                                borderRadius: 5,
                                alignContent: 'center',
                            }}
                        >
                            <Text
                                label="Volver"
                                textAlign={'center'}
                                color={'white'}
                                fontWeight={700}
                                fontSize={14}
                                fontFamily={'Montserrat'}
                            />
                        </div>
                        <div
                            style={{
                                height: 36,
                                width: 141,
                                backgroundColor: '#74BF00',
                                borderRadius: 5,
                                alignContent: 'center',
                                marginBottom: 20,
                            }}
                        >
                            <Text
                                label="Publicar"
                                textAlign={'center'}
                                color={'white'}
                                fontWeight={700}
                                fontSize={14}
                                fontFamily={'Montserrat'}
                            />
                        </div>
                    </div>
                </div>
            </ModalComponent>
        )
    }
    const productPublishOkModal = () => {
        return (
            <ModalComponent
                show={showProductPublishOkModal}
                handleClose={() => setShowProductPublishOkModal(false)}
                modalStyle={styles.inventoryModalStyle}
            >
                <div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: 30,
                        }}
                    >
                        <img src={greenOk} width={117} height={117} />
                    </div>

                    <Text
                        label="Su producto ha sido creado con éxito."
                        fontWeight={500}
                        fontSize={16}
                        textAlign={'center'}
                        marginTop={10}
                        marginBottom={30}
                        fontFamily={'Montserrat'}
                        color={'#565656'}
                    />
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            marginLeft: 20,
                            marginRight: 20,
                        }}
                    >
                        <div
                            style={{
                                height: 36,
                                width: 168,
                                backgroundColor: '#006BAB',
                                borderRadius: 5,
                                alignContent: 'center',
                            }}
                        >
                            <Text
                                label="Crear nuevo producto"
                                textAlign={'center'}
                                color={'white'}
                                fontWeight={700}
                                fontSize={14}
                                fontFamily={'Montserrat'}
                            />
                        </div>
                        <div
                            style={{
                                height: 36,
                                width: 168,
                                backgroundColor: '#00B744',
                                borderRadius: 5,
                                alignContent: 'center',
                                marginBottom: 20,
                            }}
                        >
                            <Text
                                label="Ir a Mis Producto"
                                textAlign={'center'}
                                color={'white'}
                                fontWeight={700}
                                fontSize={14}
                                fontFamily={'Montserrat'}
                            />
                        </div>
                    </div>
                </div>
            </ModalComponent>
        )
    }
    const productPublishErrorModal = () => {
        return (
            <ModalComponent
                show={showProductPublishErrorModal}
                handleClose={() => setShowProductPublishErrorModal(false)}
                modalStyle={styles.inventoryModalStyle}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: 30,
                    }}
                >
                    <img src={errorRed} width={117} height={117} />
                </div>
                <Text
                    label={`Ocurrió un error al enviar la solicitud,\nintenta nuevamente.\nSi el problema persiste, contacta a\nsoporte.`}
                    fontWeight={500}
                    fontSize={16}
                    textAlign={'center'}
                    marginTop={10}
                    marginBottom={30}
                    fontFamily={'Montserrat'}
                    color={'#565656'}
                />
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <div
                        style={{
                            height: 36,
                            width: 289,
                            backgroundColor: '#00B744',
                            borderRadius: 5,
                            alignContent: 'center',
                            marginBottom: 20,
                        }}
                    >
                        <Text
                            label="Ir a Mis Producto"
                            textAlign={'center'}
                            color={'white'}
                            fontWeight={700}
                            fontSize={14}
                            fontFamily={'Montserrat'}
                        />
                    </div>
                </div>
            </ModalComponent>
        )
    }
    const clickOnDelete = () => {
        const myDiv = document.getElementById('liquidate-form')
        if (myDiv) {
            myDiv.scrollIntoView({ behavior: 'smooth' })
        }
        handleOpenConfirmDelete()
    }
    // const handleDelete = async () => {
    //     setDeleteProductMessage(true)
    //     const idProduct = data.product.id
    //     loadingContext?.onOpen()
    //     if (validateFullForm()) {
    //         try {
    //             await deleteProduct(idProduct, {
    //                 ...data,
    //                 types: ['ONLINE'],
    //             }).then((resp) => {
    //                 loadingContext?.onClose()
    //                 onCloseConfirm()
    //                 if (resp.status === 200) {
    //                     setTimeout(() => {
    //                         handleOpenResponseOk()
    //                     }, 400)
    //                 } else {
    //                     setTimeout(() => {
    //                         handleOpenResponseError()
    //                     }, 400)
    //                 }
    //             })
    //         } catch (err) {
    //             onCloseConfirm()
    //             setTimeout(() => {
    //                 handleOpenResponseError()
    //             }, 400)
    //         }
    //     }
    // }
    const handleDelete = async () => {
        const idProduct = data.product.id
        loadingContext?.onOpen()
        const types = []
        if (salesInApp) {
            types.push('ONLINE')
        }
        if (inStoreSales) {
            types.push('F2F')
        }
        try {
            await deleteProduct(idProduct, {
                ...data,
                types: ['ONLINE'],
            }).then((resp) => {
                onCloseConfirm()
                if (resp.status === 200) {
                    setTimeout(() => {
                        handleCloseResponseOk()
                        navigate(-1)
                        loadingContext?.onClose()
                    }, 400)
                } else {
                    setTimeout(() => {
                        handleCloseResponseError()
                        loadingContext?.onClose()
                    }, 400)
                }
            })
        } catch (err) {
            onCloseConfirm()
            setTimeout(() => {
                handleCloseResponseError()
            }, 400)
        }
    }

    const handleClickUpdate = () => {
        const isValid = validate()
        if (!isValid) return
        loadingContext?.onOpen()

        try {
            handleSubmitEdit()
        } catch (err) {
            loadingContext?.onClose()
            handleCloseResponseError()
        }
    }

    return (
        <div className={styles.container}>
            <ModalComponent
                show={
                    openConfirm ||
                    openConfirmDelete ||
                    openRespnseOK ||
                    openResponseError
                }
                handleClose={closeFunction ? closeFunction : () => null}
                modalStyle={styles.modalStyleContainer}
                icon={false}
            >
                {openConfirm && (
                    <ConfirmModal onClick={onSubmit} onBack={onCloseConfirm} />
                )}
                {openConfirmDelete && (
                    <DeleteProductModal
                        onClick={handleDelete}
                        onBack={onCloseConfirmDelete}
                    />
                )}
                {openRespnseOK && (
                    <div style={{ marginTop: 30 }}>
                        <LiquidateCreateResponseOK
                            buttonText="Crear nuevo producto"
                            text={labels.productSuccess}
                            onClose={handleCloseResponseOk}
                        />
                    </div>
                )}
                {openResponseError && (
                    <LiquidateError onClick={handleCloseResponseError} />
                )}
            </ModalComponent>
            <div className={styles.wrapper}>
                <div style={{ width: '100%', marginBottom: 10 }}>
                    <Text
                        label={labels.editProductTitle}
                        fontSize={27}
                        fontWeight={600}
                        color="#184287"
                    />
                </div>
                <WarningUI />
                <form ref={formRef} id="liquidate-form" className={styles.form}>
                    <div className={styles.formWrapper}>
                        <ProductType
                            isFood={!!form.isFood}
                            onChange={handleFood}
                        />
                        <div className={styles.titleWrapper}>
                            <Text
                                label={labels.productInformation}
                                variant={`${styles.textWidth}`}
                                fontWeight={600}
                                color="#184287"
                                fontSize={16}
                            />
                            <div className={styles.divider} />
                        </div>
                        <div className={styles.inputContainer}>
                            <OutlinedInput
                                disabled={isPublic}
                                formId={createProductFormIds.productName}
                                floatingLabel={labels.name}
                                onChange={handleChange}
                                value={form.productName}
                                placeholder={labels.productNamePlaceholder}
                                minLength={0}
                                error={
                                    showError ? errors?.productName && ' ' : ''
                                }
                                maxLength={42}
                                charCounter
                                min="0"
                                max="42"
                            />
                        </div>
                        <div className={styles.inputContainer}>
                            {data?.product ? (
                                <OutlinedInput
                                    disabled
                                    floatingLabel={'EAN'}
                                    value={form.ean}
                                    placeholder={'Sin EAN'}
                                />
                            ) : (
                                <AsyncSelectFromApi
                                    floatingLabel={'EAN'}
                                    placeholder={'0000000000000'}
                                    errorMessage={
                                        showError ? errors?.ean && ' ' : ''
                                    }
                                    onSelect={handleSelectEAN}
                                    empty={true}
                                    emptyLabel="El EAN ingresado no está en nuestros registros, por favor carga el producto y omite este campo."
                                    keepFirstPart
                                    searchFunctionByString={getEAN}
                                    objectToOption={eansToOption}
                                />
                            )}
                        </div>
                        <div className={styles.inputContainer}>
                            <OutlinedInput
                                formId={createProductFormIds.sku}
                                floatingLabel={'SKU'}
                                onChange={handleChange}
                                value={form.sku}
                                placeholder={'0000000000000'}
                                error={showError ? errors?.sku && ' ' : ''}
                                minLength={0}
                                maxLength={82}
                                charCounter
                                disabled={!!data?.product}
                            />
                        </div>
                        <div className={styles.inputContainer}>
                            <OutlinedInput
                                disabled={isPublic}
                                formId={createProductFormIds.fullDescription}
                                floatingLabel={labels.description}
                                onChange={handleChange}
                                value={form.fullDescription}
                                placeholder={labels.descriptionPlaceHolder}
                                error={
                                    showError
                                        ? errors?.fullDescription && ' '
                                        : ''
                                }
                                minLength={0}
                                maxLength={82}
                                charCounter
                            />
                        </div>
                        {/* <div className={styles.inputContainer}>
                            <OutlinedInput
                                disabled={isPublic}
                                formId={createProductFormIds.shortDescription}
                                floatingLabel={labels.shortDescription}
                                onChange={handleChange}
                                value={form.shortDescription}
                                placeholder={labels.productNamePlaceholder}
                                error={
                                    showError
                                        ? errors?.shortDescription && ' '
                                        : ''
                                }
                                minLength={0}
                                maxLength={64}
                                charCounter
                            />
                        </div> */}
                        <div className={styles.spaceInput}>
                            <div className={styles.inputContainer}>
                                <AsyncSelect
                                    disabled={isPublic}
                                    initValue={brandID || undefined}
                                    options={brands}
                                    floatingLabel={labels.productBrand}
                                    placeholder={labels.productBrandPlaceholder}
                                    errorMessage={
                                        showError
                                            ? errors?.productBrandID && ' '
                                            : ''
                                    }
                                    onChange={handleSelectBrand}
                                />
                            </div>
                        </div>
                        <div className={styles.spaceInput}>
                            <div className={styles.inputContainer}>
                                <AsyncSelect
                                    disabled={isPublic}
                                    options={categories}
                                    initValue={categoryID || undefined}
                                    floatingLabel={labels.classification}
                                    errorMessage={
                                        showError
                                            ? errors?.productCategoryID && ' '
                                            : ''
                                    }
                                    placeholder={
                                        labels.classificationPlaceholder
                                    }
                                    onChange={handleSelectCategory}
                                />
                            </div>
                        </div>
                        {!isPublic && (
                            <div className={styles.spaceInput}>
                                <div className={styles.inputContainer}>
                                    <OutlinedInput
                                        disabled={isPublic}
                                        formId={
                                            createProductFormIds.productImage
                                        }
                                        floatingLabel={labels.productImage}
                                        placeholder={
                                            labels.productImagePlaceholder
                                        }
                                        type="file"
                                        accept="image/*;capture=camera"
                                        onChange={handleFile}
                                        helperText={`${labels.fileSize} \n ${
                                            data && data.product
                                                ? 'Archivo actual (' +
                                                  data?.product.photoURL.slice(
                                                      data?.product.photoURL.lastIndexOf(
                                                          '/'
                                                      ) + 1,
                                                      data?.product.photoURL
                                                          .length
                                                  ) +
                                                  ')'
                                                : ''
                                        }`}
                                        error={
                                            !showError
                                                ? errors?.productImage
                                                : ''
                                        }
                                        right={
                                            <SvgIcon iconName="IconUploadImage" />
                                        }
                                    />
                                </div>
                            </div>
                        )}
                        <div className={styles.spaceInput}>
                            <div className={styles.row}>
                                <div className={styles.rowItem1}>
                                    <OutlinedSelect
                                        formId={
                                            createProductFormIds.productMeasureUnit
                                        }
                                        disabled={isPublic}
                                        floatingLabel={labels.unit}
                                        options={MEASURES}
                                        error={
                                            showError
                                                ? errors?.productMeasureUnit &&
                                                  ' '
                                                : ''
                                        }
                                        onChange={handleUnitChange}
                                    />
                                </div>
                                <div className={styles.rowItem2}>
                                    <OutlinedInput
                                        disabled={isPublic}
                                        formId={createProductFormIds.weight}
                                        floatingLabel={labels.quantity}
                                        type="text"
                                        onChange={handleChange}
                                        value={form.weight}
                                        isNumber={
                                            unit !== 'Lt' && unit !== 'Kg'
                                        }
                                        isDecimal={
                                            unit === 'Lt' || unit === 'Kg'
                                        }
                                        min="0"
                                        placeholder={labels.quantityPlaceholder}
                                        error={
                                            showError
                                                ? errors?.weight && ' '
                                                : ''
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.rowItem1}>
                                <OutlinedInput
                                    formId={createProductFormIds.price}
                                    onChange={handleChange}
                                    value={form.price}
                                    floatingLabel={labels.price}
                                    isNumber
                                    placeholder={labels.normalPlaceholder}
                                    error={
                                        showError ? errors?.price && ' ' : ''
                                    }
                                />
                            </div>
                            <div className={styles.rowItem2}>
                                <OutlinedInput
                                    formId={createProductFormIds.costPrice}
                                    floatingLabel={'Precio Costo'}
                                    onChange={handleChange}
                                    value={
                                        form.costPrice && String(form.costPrice)
                                    }
                                    isNumber
                                    placeholder={labels.quantityPlaceholder}
                                    error={
                                        showError ? errors?.stock && ' ' : ''
                                    }
                                />
                            </div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.rowItem1}>
                                <OutlinedInput
                                    formId={createProductFormIds.stock}
                                    floatingLabel={labels.stock}
                                    onChange={handleChange}
                                    value={form.stock}
                                    isNumber
                                    placeholder={labels.quantityPlaceholder}
                                    error={
                                        showError ? errors?.stock && ' ' : ''
                                    }
                                />
                            </div>
                            <div className={styles.rowItem2}>
                                <div>
                                    <CheckBox
                                        checkId="inStoreSales"
                                        labelClassName="subtitle2"
                                        label={'Venta para Tienda Física'}
                                        onClick={onToogleInStoreSales}
                                        checked={inStoreSales}
                                    />
                                </div>
                                <div>
                                    <CheckBox
                                        checkId="salesInApp"
                                        labelClassName="subtitle2"
                                        label={'Venta en app Amipass'}
                                        onClick={onToogleSalesInApp}
                                        checked={salesInApp}
                                    />
                                </div>
                            </div>
                        </div>
                        {!isPublic && (
                            <Ingredients
                                initialData={initIngredients}
                                handleIngredients={handleIngredients}
                                haveError={
                                    showError ? errors?.ingredients || '' : ''
                                }
                            />
                        )}
                        {errors?.ingredients && (
                            <div className={styles.individualError}>
                                <div className={styles.warningIcon}>
                                    <SvgIcon iconName="warning" />
                                </div>
                                <p className="subtitle3">
                                    {errors?.ingredients}
                                </p>
                            </div>
                        )}
                    </div>
                    {isEdit ? (
                        <div className={styles.buttonWrapper}>
                            <button
                                type="button"
                                className={` ButtonLg-16  ${styles.buttonDelete}`}
                                onClick={onDeleteProduct}
                            >
                                {labels.deleteProduct}
                            </button>
                            <button
                                type="button"
                                className={` ButtonLg-16 ${styles.button} ${
                                    !isValidForm ? styles.IsButtonDisabled : ''
                                }`}
                                onClick={handleClickUpdate}
                            >
                                {labels.saveChanges}
                            </button>
                        </div>
                    ) : (
                        <button
                            type="button"
                            style={{ height: 50 }}
                            className={`successBC ButtonLg-16 fullwidth ${
                                !isValidForm ? 'buttonDisabled' : ''
                            }`}
                            onClick={handleClick}
                        >
                            {labels.createProduct}
                        </button>
                    )}
                </form>
            </div>

            {productPolicyWarningModal()}
            {productPublishOkModal()}
            {productPublishErrorModal()}

            <DeleteProduct
                product={selectedDeleteProduct}
                onCancel={onDeleteCancelProduct}
                onSuccess={onDeleteSuccessProduct}
            />
        </div>
    )
}
